module.exports = __webpack_public_path__ + "img/ColoredSpace_Hero.5e07c1e5.jpg";